import { render, staticRenderFns } from "./AppSocialInstagram.vue?vue&type=template&id=5db5952e&scoped=true&"
import script from "./AppSocialInstagram.vue?vue&type=script&lang=js&"
export * from "./AppSocialInstagram.vue?vue&type=script&lang=js&"
import style0 from "./AppSocialInstagram.vue?vue&type=style&index=0&id=5db5952e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db5952e",
  null
  
)

export default component.exports